
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals/locations",
      function () {
        return require("private-next-pages/deals/locations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deals/locations"])
      });
    }
  